import { render } from "./TaxeFonciereItem.vue?vue&type=template&id=ea280a8e"
import script from "./TaxeFonciereItem.vue?vue&type=script&lang=js"
export * from "./TaxeFonciereItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__